export default "__VITE_ASSET__Dhe_KTyb__"